module.exports = "pegasus_template/assets/blocks/tile-layout-11.png";